define('bizzabo/views/popup/DeletePollView',[
    'jquery',
    'backbone',
    'bizzabo/views/popup/PopupView',
    'bizzabo/models/Global',
    'hbars!bizzabo/templates/deletePoll',
    'bizzabo/consts'
], function(
    $,
    Backbone,
    PopupView,
    Global,
    template,
    Consts
    ) {

    var DeletePollView = PopupView.extend({

        events : {
            'click .denyButton' : 'denyClicked',
            'click .allowButton' : 'allowClicked'
        },

        initialize : function(options) {
            this.popUpInitialize();
            this.model.set('title', options.title);
            this.model.set('html', options.html);
        },

        render : function() {
            var html = template(this.model.toJSON());
            this.$el.html(html);
            return this;
        },

        denyClicked : function() {
            this.hide();
        },

        allowClicked : function() {
            this.model.destroy({
                success : function() {
                    Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                        msg : 'Poll successfully deleted',
                        errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.SUCCESS,
                        autoHide : true
                    });
                },
                error: function() {
                    Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                        msg : 'Could not delete poll.',
                        errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.ERROR,
                        autoHide : true
                    });
                }
            });
            this.hide();
        }

    });

    return DeletePollView;

});
